import type { GeneralsBoardFrame, Tile } from "./generals-board-model";
import {
  boardTile,
  simulationIndex,
  simulationRows as rows,
  simulationColumns as cols,
} from "./generals-board-grid";

export type GeneralsSimulation = GeneralsBoardFrame & { tickCount: number };

export function seedGeneralsSimulation(): GeneralsSimulation {
  const tiles: Tile[] = Array.from({ length: cols * rows }, () => ({
    owner: -1,
    count: 0,
    mountain: false,
    general: false,
    castle: false,
  }));

  for (let i = 0; i < Math.floor(cols * rows * 0.14); i++) {
    boardTile({
      tiles,
      index: simulationIndex({
        x: Math.floor(Math.random() * cols),
        y: Math.floor(Math.random() * rows),
      }),
    }).mountain = true;
  }

  const bg = boardTile({
    tiles,
    index: simulationIndex({
      x: 1 + Math.floor(Math.random() * 3),
      y: rows - 2 - Math.floor(Math.random() * 3),
    }),
  });
  Object.assign(bg, {
    mountain: false,
    owner: 0,
    general: true,
    count: 1,
  });
  const rg = boardTile({
    tiles,
    index: simulationIndex({
      x: cols - 2 - Math.floor(Math.random() * 3),
      y: 1 + Math.floor(Math.random() * 3),
    }),
  });
  Object.assign(rg, {
    mountain: false,
    owner: 1,
    general: true,
    count: 1,
  });

  for (
    let placed = 0, attempts = 0;
    placed < 5 + Math.floor(Math.random() * 3) && attempts < 200;
    attempts++
  ) {
    const t = boardTile({
      tiles,
      index: simulationIndex({
        x: Math.floor(Math.random() * cols),
        y: Math.floor(Math.random() * rows),
      }),
    });

    if (t.mountain || t.general || t.castle) continue;

    t.castle = true;
    t.count = 40 + Math.floor(Math.random() * 10);
    placed++;
  }

  return { rows, cols, tiles, tickCount: 0 };
}
